import { __ } from "ramda";

export default __;
